
export const SHOW_SUCCEED_DIALOG = 'SHOW_SUCCEED_DIALOG';
export const HIDE_SUCCEED_DIALOG = 'HIDE_SUCCEED_DIALOG';
export const SHOW_FAILED_DIALOG = 'SHOW_FAILED_DIALOG';
export const HIDE_FAILED_DIALOG = 'HIDE_FAILED_DIALOG';

export const showSucceedDialog = () => {
    return dispatch => {
        dispatch({ type: SHOW_SUCCEED_DIALOG, payload: { } });
    }
}
export const hideSucceedDialog = () => {
    return dispatch => {
        dispatch({ type: HIDE_SUCCEED_DIALOG, payload: { } });
    }
}

export const showFailedDialog = () => {
    return dispatch => {
        dispatch({ type: SHOW_FAILED_DIALOG, payload: { } });
    }
}
export const hideFailedDialog = () => {
    return dispatch => {
        dispatch({ type: HIDE_FAILED_DIALOG, payload: { } });
    }
}

const ACTION_HANDLERS = {
    [SHOW_SUCCEED_DIALOG] : (state, action)=>{
        return {
            ...state,
            showSucceed : true,
        }
    },
    [HIDE_SUCCEED_DIALOG] : (state, action)=>{
        return {
            ...state,
            showSucceed: false
        }
    },
    [SHOW_FAILED_DIALOG] : (state, action)=>{
        return {
            ...state,
            showFailed : true,
        }
    },
    [HIDE_FAILED_DIALOG] : (state, action)=>{
        return {
            ...state,
            showFailed: false
        }
    },
};

const initialState = {
    showSucceed: false,
    showFailed: false
};

export default function noticeReducer(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
};